import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuftragEx } from 'src/app/api/model/model';
import { IonTextarea, ModalController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Utils } from 'src/app/api/helper/utils';

const log = new Logger("InputZeitPopupPage");

@Component({
    selector: 'app-input-zeit-popup',
    templateUrl: './input-zeit-popup.page.html',
    styleUrls: ['./input-zeit-popup.page.scss'],
    standalone: false
})
export class InputZeitPopupPage implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('textarea', { static: false }) textarea: IonTextarea;

    @Input() titel: string;
    @Input() dauerInSekunden: number;

    @Output() textChanged = new EventEmitter<string>();

    subscriptions: Subscription[] = [];

    constructor(
        private auftragService: AuftragService,
        private modalController: ModalController,
    ) { }

    async ionViewWillLeave() {
        log?.debug('ionViewWillLeave');
    }

    ngOnInit() {
        MyApp.current.klingelnBlockiert.next(true);
    }

    ngAfterViewInit() {
        MyApp.current.backAction = () => this.onAbbrechen();

        setTimeout(() => {
            try {
                if (this.textarea) {
                    this.textarea.setFocus();
                }
            } catch (err) {
                log.error('setTimeout textarea: ' + Utils.getErrorMessage(err), err);
            }
        }, 500);
    }

    async ngOnDestroy() {
        log?.debug('ngOnDestroy');

        MyApp.current.backAction = null;

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        MyApp.current.klingelnBlockiert.next(false);
    }

    onAbbrechen() {
        this.dismiss();
    }

    async onSpeichern() {
        this.dismiss();
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true,
            'text': 'TODO' // this.text
        });
    }
}
